import * as THREE from 'three'
import gsap from 'gsap'

export default class MachineIndicator
{
    constructor(_options)
    {
        this.dismissed = false
        this.opacity = 1
        this.container = new THREE.Group()
        this.container.position.set(_options.machine.x, _options.machine.y, 3.1)
        const resources = _options.resources ?? [_options.resource]
        this.items = []
        for(const [index, resource] of resources.entries())
        {
            const item = _options.factory.createItem(resource, 2.2)
            item.position.x = _options.output ? -1.15 + (index - (resources.length - 1) * 0.5) * 1.05 : 0
            if(_options.output)
                item.scale.multiplyScalar(0.82)
            this.container.add(item)
            this.items.push(item)
            if(index === 0)
                this.item = item
        }
        if(_options.output)
        {
            const output = _options.factory.createItem(_options.output, 1.8)
            output.position.x = 1.15
            this.container.add(output)
            this.items.push(output)

            const arrowMaterial = new THREE.MeshBasicMaterial({ color: 0xffe889 })
            this.arrow = new THREE.Group()
            const shaft = new THREE.Mesh(new THREE.BoxGeometry(0.72, 0.16, 0.16), arrowMaterial)
            shaft.position.x = -0.08
            const head = new THREE.Mesh(new THREE.ConeGeometry(0.27, 0.5, 12), arrowMaterial)
            head.position.x = 0.5
            head.rotation.z = - Math.PI * 0.5
            this.arrow.add(shaft, head)
            this.arrow.scale.setScalar(0.5)
            this.container.add(this.arrow)
        }
        this.materials = []
        this.container.traverse((_child) =>
        {
            if(!_child.isMesh)
                return
            _child.material = _child.material.clone()
            _child.material.transparent = true
            this.materials.push({
                material: _child.material,
                opacity: _child.material.uniforms?.opacity?.value ?? _child.material.opacity
            })
        })
    }

    update(_elapsed)
    {
        if(this.dismissed)
            return
        this.container.position.z = 3.1 + Math.sin(_elapsed * 0.004) * 0.22
    }

    dismiss()
    {
        if(this.dismissed)
            return
        this.dismissed = true
        gsap.to(this, {
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            onUpdate: () => this.setOpacity(),
            onComplete: () => this.container.visible = false
        })
    }

    setOpacity()
    {
        for(const { material, opacity } of this.materials)
        {
            if(material.uniforms?.opacity)
                material.uniforms.opacity.value = opacity * this.opacity
            else
                material.opacity = opacity * this.opacity
        }
    }
}
